exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (min-width:768px){.right[data-v-f23bb680]{width:50%;display:flex;justify-content:space-between}}.nav-link[data-v-f23bb680]{font-weight:500;color:#04141e;opacity:.5;margin-bottom:20px}", ""]);

